import {
  USUARIOS_GET_USERS_BEGIN,
  USUARIOS_GET_USERS_SUCCESS,
  USUARIOS_GET_USERS_FAILURE,
  USUARIOS_GET_USERS_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_ABM_FW, REACT_APP_IMG } from '../../../common/config';
import { FILES_ENDPOINT } from '../../../common/endpoints';
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getUsers(args = {}) {
  return async (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: USUARIOS_GET_USERS_BEGIN,
    });
    try {
      const res = await axios.get(REACT_APP_API_ABM_FW + "/users" + args);
      if (res.data.success) {
        const allUsersHavePermissions = res.data.allUsersHavePermissions;
        const users = res.data.data;
        if (users.length > 0) {
          users.forEach(user => {
            user['imagen'] = user.profilePictureUrl ? `${REACT_APP_IMG}/${user.profilePictureUrl}` : '';
            user['fullname'] = user.firstname + ' ' + user.lastname;
            user['car_lot_name'] = user.Car_lot !== null ? user.Car_lot.name : '';
            user['branch_office_name'] = user.Branch_office !== null ? user.Branch_office.name : '';
            user['role_name2'] = user.Role !== null ? user.Role.name : '';

            user['files'] = {
              'IMAGEN': []
            };
          });
          if (args !== '') {
            for (const user of users) {
              if (user.profilePictureUrl) {
                const response = await axios.get(FILES_ENDPOINT + '/USUARIO/' + user.id)
                if (response.data.data.length > 0) {
                  response.data.data.forEach((item) => {
                    user['files']['IMAGEN'].push(item);
                  })
                  if (user['files']['IMAGEN'].length > 0) {
                    user['imagen'] = REACT_APP_IMG + '/' + user['files']['IMAGEN'][0].url;
                  }
                }
              }
            }
            dispatch({
              type: USUARIOS_GET_USERS_SUCCESS,
              data: users,
              allUsersHavePermissions: allUsersHavePermissions,
              pagination: res.data.pagination
            });
            return res;
          } else {
            dispatch({
              type: USUARIOS_GET_USERS_SUCCESS,
              data: users,
              allUsersHavePermissions: allUsersHavePermissions,
              pagination: res.data.pagination
            });
            return res;
          }
        } else {
          dispatch({
            type: USUARIOS_GET_USERS_SUCCESS,
            data: []
          });
          return res;
        }
      }
    }
    catch (err) {
      dispatch({
        type: USUARIOS_GET_USERS_FAILURE,
        data: { error: err },
      });
      return err;
    }
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetUsersError() {
  return {
    type: USUARIOS_GET_USERS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USUARIOS_GET_USERS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getUsersPending: true,
        getUsersError: null,
      };

    case USUARIOS_GET_USERS_SUCCESS:
      // The request is success
      return {
        ...state,
        getUsersPending: false,
        getUsersError: null,
        userList: [...action.data],
        allUsersHavePermissions: action.allUsersHavePermissions,
        usersPagination: { ...action.pagination }
      };

    case USUARIOS_GET_USERS_FAILURE:
      // The request is failed
      return {
        ...state,
        getUsersPending: false,
        getUsersError: action.data.error,
      };

    case USUARIOS_GET_USERS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getUsersError: null,
      };

    default:
      return state;
  }
}
